/**
 * id {number, string} Column unique identificator
 * label {string} Column title
 * field_name {string} Column string identificator, used for slot reference
 * source_field {string}  Field name in the source data
 * showColumn {boolean} Enable the columns by default
 * alwaysVisible {boolean} Block making column visible / hidden
 * pinned {boolean} Pin the column
 * suppressSorting {boolead} Disable sorting
 */

export default [
  {
    id: 1,
    label: 'Email',
    field_name: 'email',
    source_field: 'email',
    customClass: 'email',
    showColumn: true,
    pinned: true,
  },
  {
    id: 2,
    label: 'First Name',
    field_name: 'first_name',
    source_field: 'first_name',
    showColumn: true,
  },
  {
    id: 3,
    label: 'Last Name',
    field_name: 'last_name',
    source_field: 'last_name',
    showColumn: true,
  },
  {
    id: 4,
    label: 'Group name',
    field_name: 'group_name',
    source_field: 'group_name',
    showColumn: true,
  },
  {
    id: 5,
    label: 'Session start time',
    field_name: 'session_started',
    source_field: 'session_started',
    showColumn: true,
  },
  {
    id: 6,
    label: 'Session end time',
    field_name: 'session_ended',
    source_field: 'session_ended',
    showColumn: true,
  },
  {
    id: 7,
    label: 'Total Session Time',
    field_name: 'total_session_time',
    source_field: 'total_session_time',
    showColumn: true,
    type: 'time',
  },
  {
    id: 8,
    label: 'Active Study Time',
    field_name: 'total_studied_in_session',
    source_field: 'total_studied_in_session',
    showColumn: false,
    type: 'time',
  },
];
